import { FC, useState } from "react";
import { useCalendar } from "../../../context/CalendarProvider";
import { getDatesRange } from "../../../utils/getDatesRange";
import { getTileProperties } from "../../../utils/getTileProperties";
import {
  ContainerStyledText,
  StyledDescription,
  StyledStickyWrapper,
  StyledText,
  StyledTextWrapper,
  StyledTileWrapper,
} from "./styles";
import { TileProps } from "./types";
import { ModalFormAlocation } from "../../ModalFormAllocation";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";
import { toast } from "react-toastify";

const Tile: FC<TileProps> = ({ row, data, zoom, onTileClick }) => {
  const { date } = useCalendar();
  const datesRange = getDatesRange(date, zoom);
  const { y, x, width } = getTileProperties(
    row,
    datesRange.startDate,
    datesRange.endDate,
    data.startDate,
    data.endDate,
    zoom
  );

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const permissions = usePermission(FeatureStatic.allocationMap.id);

  const isProjection = data.isProjection && !data.linkId && !data.customerName;

  const getTileStyles = () => {
    let borderLeft = "";
    let backgroundColor = "";

    if (isProjection) {
      borderLeft = "4px solid rgb(0, 138, 253)";
      backgroundColor = "rgb(219, 250, 255)";
    } else if (data.isProject) {
      if (data.linkId) {
        borderLeft = "4px solid #781AA0";
        backgroundColor = "#f0e1f4";
      } else {
        borderLeft = "4px solid rgb(170, 255, 30)";
        backgroundColor = "rgb(244, 255, 204)";
      }
    } else {
      borderLeft = "4px solid #ff1e1e";
      backgroundColor = "#ffcccc";
    }

    return { borderLeft, backgroundColor };
  };

  return (
    <>
      <StyledTileWrapper
        title={`${data.title} ${
          data.customerName ? "| " + data.customerName : ""
        }`}
        style={{
          left: `${x}px`,
          top: `${y}px`,
          ...getTileStyles(),
          width: `${width}px`,
          color: "#212121",
        }}
        onClick={() => {
          if (permissions.canEdit(undefined, data.managerId)) handleOpen();
          else toast.error(`Você não tem permissão para editar uma alocação`);
        }}
      >
        <StyledTextWrapper>
          <StyledStickyWrapper>
            <ContainerStyledText>
              {data.linkId && (
                <svg
                  width="20"
                  height="14"
                  viewBox="0 0 20 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "10px" }}
                >
                  <path
                    d="M13.6364 6C15.1455 6 16.3545 4.66 16.3545 3C16.3545 1.34 15.1455 0 13.6364 0C12.1273 0 10.9091 1.34 10.9091 3C10.9091 4.66 12.1273 6 13.6364 6ZM6.36364 6C7.87273 6 9.08182 4.66 9.08182 3C9.08182 1.34 7.87273 0 6.36364 0C4.85455 0 3.63636 1.34 3.63636 3C3.63636 4.66 4.85455 6 6.36364 6ZM6.36364 8C4.24545 8 0 9.17 0 11.5V14H12.7273V11.5C12.7273 9.17 8.48182 8 6.36364 8ZM13.6364 8C13.3727 8 13.0727 8.02 12.7545 8.05C13.8091 8.89 14.5455 10.02 14.5455 11.5V14H20V11.5C20 9.17 15.7545 8 13.6364 8Z"
                    fill={"#212121"}
                  />
                </svg>
              )}
              <StyledText bold>{data.title}</StyledText>
              {data.customerName && (
                <StyledText> | {data.customerName}</StyledText>
              )}
            </ContainerStyledText>

            <StyledDescription>
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5025 0.0839844C3.01397 0.0839844 0.1875 2.91046 0.1875 6.39898C0.1875 9.88751 3.01397 12.714 6.5025 12.714C9.99103 12.714 12.8175 9.88751 12.8175 6.39898C12.8175 2.91046 9.99103 0.0839844 6.5025 0.0839844ZM12.0027 6.39898C12.0027 9.42153 9.5556 11.8991 6.5025 11.8991C3.47996 11.8991 1.00234 9.45208 1.00234 6.39898C1.00234 3.37644 3.4494 0.898823 6.5025 0.898823C9.52504 0.898823 12.0027 3.34589 12.0027 6.39898ZM8.21111 8.64743L6.14346 7.14507C6.06452 7.0865 6.01869 6.99484 6.01869 6.89807V2.83406C6.01869 2.666 6.15619 2.5285 6.32425 2.5285H6.68075C6.84881 2.5285 6.98631 2.666 6.98631 2.83406V6.55941L8.7815 7.86569C8.91901 7.965 8.94702 8.15598 8.84771 8.29348L8.63891 8.58122C8.5396 8.71618 8.34862 8.74674 8.21111 8.64743Z"
                  fill={"#212121"}
                />
              </svg>
              <span
                style={{
                  fontSize: "10px",
                  fontWeight: "400",
                  textShadow: "0px 0px rgba(0,0,0, 1)",
                }}
              >
                {data.isMonthAllocation
                  ? `${data.isProject ? "" : "-"}${
                      data.monthAllocationHours
                    }h por mês`
                  : `${data.isProject ? "" : "-"}${data.hoursPerDay}h por dia`}
              </span>
            </StyledDescription>
          </StyledStickyWrapper>
        </StyledTextWrapper>
      </StyledTileWrapper>
      <ModalFormAlocation
        isEdit
        dataAllocation={{
          id: data.id,
          isProject: data.isProject,
          startDate: data.startDate,
          endDate: data.endDate,
          title: data.title,
          bgColor: data.bgColor,
          description: data.description,
          subtitle: data.subtitle,
          occupancy: data.occupancy,
        }}
        open={open}
        handleClose={handleClose}
      />
    </>
  );
};

export default Tile;
